import React, { useEffect, useState } from "react";

import ReactHtmlParser from "react-html-parser";

import HeaderElement from "../../../components/header";
import BackButtom from "../../../components/backButton";

import LucralizeLogo from "../../../assets/svgs/LucralizeLogo.svg";
import { theme } from "../../../styles/theme";
import * as S from "./styles";

import { api } from "../../../../infra/http/remote";

const TermsUse = (): JSX.Element => {
  const [data, setData] = useState<any>("");

  useEffect(() => {
    (async () => {
      const termData = await api.get("/public/register/term-privacy");
      setData(termData?.data || "");
    })();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        backgroundColor: theme.colors.blue900,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "20px",
        }}
      >
        <HeaderElement style={{ width: "100%" }}>
          <img alt="" src={LucralizeLogo} />
        </HeaderElement>
        <div
          style={{
            height: "100vh",
          }}
        >
          <BackButtom text="Voltar para tela inicial" />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                marginTop: "60px",
                borderRadius: "25px",
                display: "flex",
                flexDirection: "column",
                padding: "35px",
                width: "75%",
                backgroundColor: theme.colors.darkBlue,
                color: theme.colors.white,
              }}
            >
              <S.TermsContainer>
                <h2
                  style={{
                    textAlign: "center",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    marginBottom: "30px",
                  }}
                >
                  Termos de privacidade:
                </h2>
                <span style={{ fontFamily: "Poppins" }}>
                  {ReactHtmlParser(data)}
                </span>
              </S.TermsContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TermsUse;
